import { Result, validatedApiCall } from '../api';
import { Area } from '../../types/areas/areas';
import { APIValidationError } from '../../types/api/api';

interface DataAreas {
  data: Area[];
}

export const getAreas = async (): Promise<
  Result<DataAreas, APIValidationError>
> => {
  return validatedApiCall<DataAreas>(`/api/areas`, {
    method: 'GET',
    auth: true,
  });
};
